export default "https://assets.pclncdn.com/web/next-landing/04b488bed1/_next/static/images/cobrand-cheap-cruises-promo-c1022ed4b31cfa1f3c44a2ac2331806f.jpg";